import React from 'react';

interface IRefreshIconProps {
  size?: number;
  strokeWidth?: number;
  stroke?: string;
  className?: string;
  gap?: number;
}

const RefreshIcon: React.FC<IRefreshIconProps> = ({
    size = 60,
    strokeWidth = 2,
    stroke = 'currentColor',
    gap = 4,
    className,
  }) => {
    const radius = (size - strokeWidth * 2) / 2;
    const cx = size / 2;
    const cy = size / 2;
  
    // Left and right x-coordinates with a gap
    const x1 = cx - radius + gap;
    const x2 = cx + radius - gap;
    const y = cy;
  
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={stroke}
        className={className}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Top semicircle arc (upward) */}
        <path d={`M ${x1},${y} A ${radius},${radius} 0 1 1 ${x2},${y}`} />

        {/* Top arc arrowhead (left side, pointing up) */}
        <path d={`M ${x1},${y} l -6,-6`} />
        <path d={`M ${x1},${y} l 6,-6`} />

        {/* Bottom semicircle arc (downward) */}
        <path d={`M ${x1},${y} A ${radius},${radius} 0 1 0 ${x2},${y}`} />

        {/* Bottom arc arrowhead (right side, pointing down) */}
        <path d={`M ${x2},${y} l -6,6`} />
        <path d={`M ${x2},${y} l 6,6`} />
      </svg>
    );
  };

export default RefreshIcon;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/RefreshIcon.tsx